import _ from 'lodash';
import { arrayAny } from '../../utils/arrayUtils';

export class PropertyFunctions {

    static formatBlobStorageGalleryString = (input, docId, imageName) => {

        const result = input.startsWith("https") ?
            `${docId}${(new URL(decodeURIComponent(input))).pathname.split(`/${docId}`)[1]}` :
            imageName ? decodeURIComponent(`${docId}/Gallery/${imageName}`) :
                input;

        return decodeURIComponent(result);
    }

    static addImagesToProperty = (propertyDoc, images, savePropertyCallBack) => {

        const newPropDoc = structuredClone(propertyDoc);

        const newImageItems = images.map(i => {

            return {
                isPrimaryImage: false,
                path: "placeholder",
                name: i.name.split(":")[0],
                caption: i.name.split(":")[0],
                description: "Please enter meaningful description",
                rating: 0,
                title: "Please enter title",
                dimensions: { width: 0, height: 0 }
            }
        });

        newPropDoc.property.photoGallery = [].concat(newPropDoc.property.photoGallery, newImageItems);

        const dimensionsCallback = (img, dims) => {

            const image = _.find(newPropDoc.property.photoGallery, p => p.path === "placeholder" && p.name && p.name.endsWith(img.name.split(":")[0]));
            image.path = img.src;
            image.dimensions = dims;


            let gallery = [];
            newPropDoc.property.photoGallery.map(pg => gallery = [].concat(gallery, pg));
            newPropDoc.property.photoGallery = gallery;

            if (!_.find(gallery, p => p.path === 'placeholder') &&
                arrayAny(_.filter(gallery, p => p.path.startsWith("data:image")))) {
                savePropertyCallBack(newPropDoc);
            }

        };

        PropertyFunctions.readImageFiles(images, dimensionsCallback);
    };

    static readImageFiles = (collection, callback) => {

        if (collection.length === 0) {
            return;
        }

        // Load new images without needing to re-fetch from server
        for (const imageInfo of collection) {

            const reader = new FileReader();
            reader.onload = (e) => {

                const data = e.target.result;

                const img = new Image();
                img.src = data;

                img.onload = (e) => {
                    if (callback) {
                        imageInfo.src = img.src;
                        callback(imageInfo, { width: img.naturalWidth, height: img.naturalHeight })
                    }
                };
            }
            reader.readAsDataURL(imageInfo);
        }
    };

    static createPropertyModel = ({ name, landlordOrOwnerId, landlordOrOwner, landlord, doorNumberOrName, roadName, town, postCode }) => {

        const resolvedLandlordOrOwnerId = landlordOrOwnerId ?? landlordOrOwner ?? landlord;

        const propertyModel = {
            doorNumberOrName: doorNumberOrName,
            keyCodes: null,
            landlordOrOwner: resolvedLandlordOrOwnerId,
            name: name,
            photoGallery: null,
            postalCode: postCode,
            propertyType: "SINGLE_LET",
            roadName: roadName,
            rooms: null,
            selectedProject: -1,
            town: town

        };
        return propertyModel;
    };

}